import { render, staticRenderFns } from "./m_register.vue?vue&type=template&id=72dd4294&scoped=true&"
import script from "./m_register.vue?vue&type=script&lang=js&"
export * from "./m_register.vue?vue&type=script&lang=js&"
import style0 from "./m_register.vue?vue&type=style&index=0&id=72dd4294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd4294",
  null
  
)

export default component.exports